、<template>
  <div>
    <!-- 原HTML结构保持不变，添加点击事件 -->
    <div class="md:min-h-[96px] mt-6 w-full">
      <div class="flex flex-wrap gap-2 w-full sm:max-w-[545px]">
        <a 
          class="openai-button-secondary"
          @click.prevent="openVideo(videos.english)"
        >
          <span class="relative">
            Podcast: Beyond Selling - How Untrading is Fixing a Broken System
          </span>
        </a>
        
        <a 
          class="openai-button-secondary"
          @click.prevent="openVideo(videos.chinese)"
        >
          <span class="relative">
            播客：退出即开始 - Untrading 如何终结 90% 交易者的亏损困境
          </span>
        </a>
      </div>
    </div>

    <!-- 视频弹窗模态框 - 背景遮罩 -->
    <div 
      v-if="dialog" 
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
      @click.self="closeVideo"
    >
      <!-- 关闭按钮 -->
      <button 
        @click="closeVideo"
        class="absolute top-4 right-4 z-60 w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-200"
      >
        ×
      </button>
      
      <!-- 视频播放区域 - 调整尺寸 -->
      <div class="video-container">
        <iframe
          v-if="currentVideo.url"
          :src="currentVideo.url"
          class="video-iframe"
          frameborder="0"
          allowfullscreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoLinksComponent',
  data() {
    return {
      dialog: false,
      currentVideo: {
        title: '',
        url: ''
      },
      videos: {
        english: {
          title: 'Beyond Selling - How Untrading is Fixing a Broken System',
          url: 'https://customer-cc44yfs1ng5d1ck2.cloudflarestream.com/f67478ee75621cda450a690003a29161/iframe?poster=https%3A%2F%2Fcustomer-cc44yfs1ng5d1ck2.cloudflarestream.com%2Ff67478ee75621cda450a690003a29161%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600'
        },
        chinese: {
          title: '退出即开始 - Untrading 如何终结 90% 交易者的亏损困境',
          url: 'https://customer-cc44yfs1ng5d1ck2.cloudflarestream.com/7fc1005c2515e4f4d49d700b9a333cdf/iframe?autoplay=true&poster=https%3A%2F%2Fcustomer-cc44yfs1ng5d1ck2.cloudflarestream.com%2F7fc1005c2515e4f4d49d700b9a333cdf%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600'
        }
      }
    }
  },
  methods: {
    openVideo(video) {
      this.currentVideo = { ...video }
      this.dialog = true
      // 防止页面滚动
      document.body.style.overflow = 'hidden'
    },
    closeVideo() {
      this.dialog = false
      // 恢复页面滚动
      document.body.style.overflow = 'auto'
      // 延迟清空视频URL，避免关闭时闪烁
      setTimeout(() => {
        this.currentVideo = { title: '', url: '' }
      }, 300)
    }
  },
  beforeUnmount() {
    // 组件销毁时恢复页面滚动
    document.body.style.overflow = 'auto'
  }
}
</script>

<style scoped>
/* OpenAI次要按钮样式 - 移动端优化 */
.openai-button-secondary {
  display: inline-flex;
  align-items: center;
  min-height: 40px; /* 改为最小高度 */
  padding: 8px 16px; /* 调整内边距 */
  border: 1px solid rgb(var(--v-theme-border-1), 0.2);
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.15s ease;
  cursor: pointer;
  white-space: normal; /* 允许换行 */
  margin: 4px;
  box-sizing: border-box;
  line-height: 1.4; /* 增加行高 */
  text-align: center; /* 文本居中 */
  word-break: break-word; /* 单词换行 */
}

.openai-button-secondary:hover {
  background: rgb(var(--v-theme-bg-1));
  border-color: rgba(var(--v-theme-border-1), 0.2);
}

/* 移动端按钮优化 */
@media (max-width: 768px) {
  .openai-button-secondary {
    min-height: 48px; /* 移动端增加触摸区域 */
    padding: 12px 16px; /* 增加内边距 */
    font-size: 16px;
    margin: 3px; /* 减少外边距 */
    width: 100%; /* 占满容器宽度 */
    text-align: left;
  }
  
  /* 按钮容器在移动端的调整 */
  .flex.flex-wrap.gap-2 {
    gap: 6px; /* 减少间距 */
    flex-direction: column; /* 移动端垂直排列 */
  }
}

/* 小屏手机优化 */
@media (max-width: 480px) {
  .openai-button-secondary {
    min-height: 52px; /* 进一步增加触摸区域 */
    padding: 14px 20px;
    font-size: 15px; /* 稍微增大字体 */
    margin: 2px;
    border-radius: 20px; /* 调整圆角 */
  }
}

/* 超小屏优化 */
@media (max-width: 360px) {
  .openai-button-secondary {
    min-height: 56px; /* 最大的触摸区域 */
    padding: 16px 18px;
    font-size: 14px;
    margin: 2px;
    border-radius: 18px;
  }
}

/* 视频容器样式 - 正方形设计 */
.video-container {
  position: relative;
  width: 90%;
  max-width: 600px; /* 正方形容器，调整最大宽度 */
  aspect-ratio: 1/1; /* 正方形比例 */
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

.video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

/* 弹窗动画效果 */
.fixed {
  animation: fadeIn 0.3s ease-out;
}

.video-container {
  animation: slideIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { 
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to { 
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* 视频弹窗移动端优化 */
@media (max-width: 768px) {
  .video-container {
    width: 95%;
    max-width: 90vw; /* 手机端使用视窗宽度 */
    aspect-ratio: 1/1; /* 保持正方形 */
  }
  
  /* 关闭按钮在手机端更大更容易点击 */
  .fixed button {
    width: 44px;
    height: 44px;
    top: 10px;
    right: 10px;
    font-size: 24px;
  }
}

/* 小屏手机视频优化 */
@media (max-width: 480px) {
  .video-container {
    width: 95%;
    max-width: 95vw;
    aspect-ratio: 1/1; /* 保持正方形 */
  }
}

/* 超小屏视频优化 */
@media (max-width: 360px) {
  .video-container {
    width: 98%;
    max-width: 98vw;
    aspect-ratio: 1/1; /* 保持正方形 */
  }
}

/* 确保Tailwind CSS类正常工作 */
@media (min-width: 768px) {
  .md\:min-h-\[96px\] {
    min-height: 96px;
  }
}

@media (min-width: 640px) {
  .sm\:max-w-\[545px\] {
    max-width: 545px;
  }
}

/* 高度较小的设备优化 */
@media (max-height: 600px) {
  .video-container {
    max-height: 70vh;
    max-width: 70vh; /* 保持正方形 */
    aspect-ratio: 1/1;
  }
}

/* 横屏模式优化 */
@media (orientation: landscape) and (max-height: 480px) {
  .openai-button-secondary {
    min-height: 40px; /* 横屏时减小高度 */
    padding: 8px 16px;
    font-size: 13px;
  }
}
</style>